<template>
  <div class="post" v-if="event">
    <router-link :to="`/events/${event.id}`">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="489.58" height="438.475" viewBox="0 0 489.58 438.475"><defs><pattern :id="`${event.id}-aaaa`" width="100%" height="100%" v-if="image"><image x="0" y="0" :width="image.width" :height="image.height" :transform="`translate(${image.x} ${image.y})`" :xlink:href="event.image"/></pattern><filter :id="`${event.id}-b`" x="10.25" y="34.726" width="467.123" height="403.749" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="c"/><feFlood flood-opacity="0.059"/><feComposite operator="in" in2="c"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(-227.211 -3281.57)"><g transform="matrix(1, 0, 0, 1, 227.21, 3281.57)"><path d="M6.051,125.942c84.531-33.719,160.758-90.648,273.4-46.953s36.735,205.856-11.767,270.376S88.37,376.1,20.544,313.327-78.48,159.66,6.051,125.942Z" transform="translate(97.34 -0.41)" :fill="`url(#${event.id}-aaaa)`"/></g><path d="M52.024,65.007C131.378-34.7,217.6-12.679,292.072,83.294S138.88,503.023,64.408,407.05-27.33,164.71,52.024,65.007Z" transform="matrix(-0.259, 0.966, -0.966, -0.259, 716.791, 3404.076)" fill="#8abb2a" opacity="0.12"/><path d="M13.107-5.478c5.7.5,10.633,9.507,9.668,15.392s-8.862,8.148-13.526,8.148S-.991,13.617-.037,7.932,7.4-5.974,13.107-5.478Z" transform="translate(314.886 3622.969)" fill="#8abb2a" opacity="0.12"/><path d="M20.23.033c8.706.756,16.232,14.513,14.76,23.5S21.46,35.969,14.34,35.969-1.292,29.184.164,20.506,11.523-.723,20.23.033Z" transform="translate(501.263 3312.032) rotate(-60)" fill="#8abb2a" opacity="0.12"/></g></svg>
    </router-link>
    <div class="post-author">{{event.location}}</div>
    <div class="post-title" ref="title"><span>{{event.title}}</span></div>
    <div class="post-date"><DateFormat format="%Lm %d, %Y" :date="event.date.toDate()" /></div>
    <router-link class="post-read" :to="`/events/${event.id}`"><span class="text">Discover event</span><span class="plus">+</span></router-link>
  </div>
</template>

<script>
import DateFormat from './DateFormat'

export default {
  name: 'EventItem',
  components: {
    DateFormat
  },
  props: {
    event: {
      type: Object
    },
  },
  data() {
    return {
      image: null
    }
  },
  watch: {
    event(p) {
      if(p) {
        this.loadImage(p.image)
        this.sizeTitle()
      }
    }
  },
  methods: {
    loadImage(src) {
      this.$nextTick(() => {
        const img = new Image()
        img.onload = () => {
          const imgWidth = 400
          const imgHeight = 360
          const ratio = img.width > img.height ? imgHeight / img.height : imgWidth / img.width
          const width = img.width > img.height ? img.width * ratio : imgWidth
          const height = img.width <= img.height ? img.height * ratio : imgHeight
          const x = (width - imgWidth) / -2
          const y = (height - imgHeight) / -2
          this.image = {
            href: img.src,
            width,
            height,
            x,
            y
          }
          img.remove()
        }
        img.onerror = () => this.image = null
        img.src = src
      })
    },
    sizeTitle() {
      this.$nextTick(() => {
        const container = this.$refs.title.querySelector('span')
        for(let size = 100; size >= 10; size--) {
          if(this.$refs.title.clientHeight >= container.clientHeight) break
          container.style.fontSize = `${size}px`
        }
      })
    }
  },
  mounted: function() {
    if(this.event) {
      this.loadImage(this.event.image)
      this.sizeTitle()
    }
    window.addEventListener('resize', this.sizeTitle)
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.sizeTitle)
  }
}
</script>

<style scoped>
.post {
  position: relative;
  text-align: center;
  padding-bottom: 32px;
}

.post svg {
  display: block;
  width: 100%;
  height: auto;
  max-width: 400px;
  margin: auto;
}

.post .post-image {
  width: 392px;
  height: 385px;
  max-width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin: 0 auto 45px;
}

.post .post-author {
  font-size: .72em;
  letter-spacing: .58em;
  opacity: .77;
  text-transform: uppercase;
}

.post .post-title {
  position: relative;
  font: bold 2.28em/1 'Butler';
  padding: 0 20%;
  margin: 14px 0 8px;
  overflow: hidden;
  height: 100px;
}

.post .post-title span {
  display: block;
  line-height: 1.1875;
}

.post .post-date {
  font-size: 1.28em;
  font-weight: bold;
  color: #8ABB2A;
  letter-spacing: .2em;
  margin-bottom: 18px;
}

.post .post-read {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 240px;
  color: #F77E0B;
  font-size: .72em;
  letter-spacing: .58em;
  text-transform: uppercase;
  text-align: left;
}

.post .post-read:after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background: rgba(247, 125, 11, .25);
  transition: width .16s ease-out;
  margin: 4px auto 0;
}

.post .post-read .plus {
  position: absolute;
  right: 0;
  bottom: 5px;
  letter-spacing: 0;
  transition: opacity .16s ease-out .08s;
}

.post .post-read .text {
  display: inline-block;
  transition: transform .16s ease-out;
  will-change: transform;
}

@media screen and (min-width: 1025px) {
  .post .post-read:hover:after {
    transition: width .24s ease-out .16s;
    width: 160px;
  }
  .post .post-read:hover .text {
    transition: transform .16s ease-in-out .08s;
    transform: translateX(40px);
  }
  .post .post-read:hover .plus {
    transition: opacity .16s ease-out;
    opacity: 0;
  }
}

.post .post-image {
  width: auto;
  margin: auto;
  height: 412px;
}

.post .post-read {
  color: #8ABB2A;
  border-color: rgba(139, 187, 42, .25);
}

.post .post-read:after {
  background: rgba(139, 187, 42, .25);
}

@media screen and (max-width: 1024px) {
  .post .post-author {
    margin-top: -24px;
  }
  .post .post-date {
    margin-bottom: 8px;
  }
  .post .post-read {
    width: 220px;
    font-size: 11px;
  }
}
</style>
